import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import type { Product } from "../types/product";

export type WorkspaceCreationInput = {
  name: string;
  slug: string;
  productId: string;
  priceId: string;
  seats?: number;
};

export function useWorkspaceCreation() {
  const products = useQuery({
    queryKey: ["products", "workspace-creation"],
    queryFn: () => api<{ items: Product[] }>("/products"),
  });
  const createFree = useMutation({
    mutationFn: (input: WorkspaceCreationInput) =>
      api<{ id: string }>("/workspaces", {
        method: "POST",
        body: JSON.stringify(input),
      }),
  });
  const createCheckout = useMutation({
    mutationFn: (input: WorkspaceCreationInput) =>
      api<{
        checkoutSessionId: string;
        checkoutUrl: string;
        expiresAt: string;
      }>("/billing/checkout-session", {
        method: "POST",
        body: JSON.stringify(input),
      }),
  });

  return { products, createFree, createCheckout };
}

export function useCheckoutStatus(sessionId: string | null) {
  return useQuery({
    queryKey: ["billing-checkout", sessionId],
    enabled: Boolean(sessionId),
    queryFn: () =>
      api<{ status: string; workspaceId: string | null }>(
        `/billing/checkout-session/${sessionId}`,
      ),
    refetchInterval: (query) =>
      query.state.data?.status === "pending" ? 1_500 : false,
  });
}
